// ** React Imports
import { useCallback, useEffect, useState } from 'react'
import { useExtremeUpgradeRefresh } from 'src/hooks/useExtremeUpgradeRefresh'


import { useTranslation } from 'src/utils/i18n'

// ** MUI Imports
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import IconButton from '@mui/material/IconButton'

// ** Store & Actions Imports
import { useDispatch, useSelector } from 'react-redux'
import { selectMessage, fetchUserProfile, fetchChatsContacts, removeSelectedChat } from 'src/store/apps/line'

// ** Hooks
import { useSettings } from 'src/@core/hooks/useSettings'

// ** Utils Imports
import { getInitials } from 'src/@core/utils/get-initials'
import { formatDateToMonthShort } from 'src/@core/utils/format'

// ** Chat App Components Imports
import LineSideBar from 'src/@core/components/line/line-side-bar'
import LineContent from 'src/@core/components/line/line-content'
import LineTelephone from 'src/@core/components/line/line-call'
import LineContacts from 'src/@core/components/line/line-contacts'
import Image from 'next/image'
import { Icon } from '@iconify/react'
import { setCurrentTab } from 'src/store/apps/Common'
import ExtremeUpgradeModal from 'src/@core/components/modal/extreme-upgrade'
import { useExtremeFeatureAccessGate } from 'src/hooks/useExtremeFeatureAccessGate'

const callData = {
  calls: [
    {
      id: 1,
      name: 'Aiden',
      img: '/images/line/1.jpg',
      icon: 'fluent:call-inbound-16-filled',
      time: 'Nov 11, 08:41 pm',
      Time: '19s',
      state: -1
    },
    {
      id: 2,
      name: 'Jacob ',
      img: '/images/line/2.jpg',
      icon: 'fluent:call-inbound-16-filled',
      time: 'Nov 11, 08:41 pm',
      Time: '19s',
      state: -1
    },
    {
      id: 3,
      name: 'Ethan ',
      img: '/images/line/3.jpg',
      icon: 'fluent:call-outbound-16-filled',
      time: 'Nov 11, 08:41 pm',
      Time: '40s',
      state: 1
    },
    {
      id: 4,
      name: 'Caden ',
      img: '/images/line/4.jpg',
      icon: 'fluent:call-inbound-16-filled',
      time: 'Nov 11, 08:39 pm',
      Time: '20s',
      state: -1
    },
    {
      id: 5,
      name: 'Jackson ',
      img: '/images/line/5.jpg',
      icon: 'fluent:call-inbound-16-filled',
      time: 'Nov 11, 08:25 pm',
      Time: '34s',
      state: -1
    },
    {
      id: 6,
      name: 'Smith ',
      img: '/images/line/6.jpg',
      icon: 'fluent:call-outbound-16-filled',
      time: 'Nov 11, 08:10 pm',
      Time: '19s',
      state: 1
    },
    {
      id: 7,
      name: 'Smith',
      img: '/images/line/6.jpg',
      icon: 'fluent:call-outbound-16-filled',
      time: 'Nov 11, 08:12 pm',
      Time: '41s',
      state: 1,
      State: false
    },
    {
      id: 8,
      name: 'Sammy ',
      img: '/images/line/8.jpg',
      icon: 'fluent:call-outbound-16-filled',
      time: 'Nov 11, 07:41 pm',
      Time: '59s',
      state: 1
    },
    {
      id: 9,
      name: 'Jacob',
      img: '/images/line/2.jpg',
      icon: 'fluent:call-outbound-16-filled',
      time: 'Nov 11, 07:00 pm',
      Time: '10s',
      state: 1
    },
    {
      id: 10,
      name: 'Jackson',
      img: '/images/line/5.jpg',
      icon: 'fluent:call-inbound-16-filled',
      time: 'Nov 11, 05:00 pm',
      Time: '45s',
      state: -1
    },
    {
      id: 11,
      name: 'Aiden',
      img: '/images/line/1.jpg',
      icon: 'fluent:call-outbound-16-filled',
      time: 'Nov 11, 04:50 pm',
      Time: '1m 25s',
      state: 1
    }
  ],

  contacts: [
    {
      id: 1,
      name: 'Sarah',
      img: '/images/line/2.jpg'
    },
    {
      id: 2,
      name: 'Jacob',
      img: '/images/line/2.jpg'
    },
    {
      id: 3,
      name: 'Ethan',
      img: '/images/line/3.jpg'
    },
    {
      id: 4,
      name: 'Caden',
      img: '/images/line/4.jpg'
    },
    {
      id: 5,
      name: 'Jackson',
      img: '/images/line/5.jpg'
    },
    {
      id: 6,
      name: 'Smith',
      img: '/images/line/6.jpg'
    },
    {
      id: 7,
      name: 'Johny',
      img: '/images/line/7.jpg'
    },
    {
      id: 8,
      name: 'Sammy',
      img: '/images/line/8.jpg'
    },
    {
      id: 9,
      name: 'Olivia',
      img: '/images/call-log/2.webp'
    },
    {
      id: 11,
      name: 'Aiden',
      img: '/images/line/1.jpg'
    },
    {
      id: 12,
      name: 'Billie',
      img: '/images/call-log/4.webp'
    },
    {
      id: 13,
      name: 'Green',
      img: '/images/call-log/8.webp'
    },
    {
      id: 14,
      name: 'Cameron',
      img: '/images/line/4.jpg'
    },
    {
      id: 15,
      name: '+6180650048',
      img: '/images/line/5.jpg'
    },
    {
      id: 16,
      name: '+6176429832',
      img: '/images/line/6.jpg'
    },
    {
      id: 17,
      name: '+6145575780',
      img: '/images/line/7.jpg'
    },
    {
      id: 18,
      name: '+6105280088',
      img: '/images/line/8.jpg'
    },
    {
      id: 19,
      name: 'Sarah',
      img: '/images/line/2.jpg'
    },
    { id: 21, name: 'Rebecca', img: '/images/call-log/11.webp' },
    {
      id: 22,
      name: 'Amy',
      img: '/images/line/1.jpg'
    }
  ]
}

const Line = () => {
  let Advanced = window.localStorage.getItem('Advanced')
  Advanced = Advanced == null || Advanced == 0 ? true : false

  // ** States
  const [userStatus, setUserStatus] = useState('online')
  const [leftSidebarOpen, setLeftSidebarOpen] = useState(true)
  const [userProfileLeftOpen, setUserProfileLeftOpen] = useState(false)
  const [userProfileRightOpen, setUserProfileRightOpen] = useState(false)
  const [leftScrollTop, setLeftScrollTop] = useState(0)

  // ** Hooks
  const theme = useTheme()
  const { settings } = useSettings()
  const dispatch = useDispatch()
  const hidden = useMediaQuery(theme.breakpoints.down('lg'))

  const store = useSelector(state => state.Line)
  const storeCommon = useSelector(state => state.Common)

  // ** Vars
  const { skin } = settings
  const smAbove = useMediaQuery(theme.breakpoints.up('sm'))
  const sidebarWidth = smAbove ? 370 : '100%'
  const mdAbove = useMediaQuery(theme.breakpoints.up('md'))

  const [chat, setChat] = useState(true)
  const [calls, setCalls] = useState(false)
  const [headImg, setHaedImg] = useState('/images/line/1.jpg')

  const [contacts, setContacts] = useState(false)

  const callHandler = () => {
    setChat(false)
    setContacts(false)
    setCalls(true)
  }

  const contactsHandler = () => {
    setChat(false)
    setCalls(false)
    setContacts(true)
  }

  const ChatHandler = () => {
    setChat(true)
    setCalls(false)
    setContacts(false)
  }
  useEffect(() => {
    dispatch(fetchChatsContacts())
  }, [dispatch])
  const handleLeftSidebarToggle = () => setLeftSidebarOpen(prev => !prev)
  const handleUserProfileLeftSidebarToggle = () => setUserProfileLeftOpen(prev => !prev)
  const handleUserProfileRightSidebarToggle = () => setUserProfileRightOpen(prev => !prev)

  const { t, locale } = useTranslation('common')
  useEffect(() => {
    const title = t('Line')
    dispatch(setCurrentTab(title))

    return () => dispatch(setCurrentTab(''))
  }, [dispatch, locale])

  const [advanced, setAdvanced] = useState(true) // 是否购买高级服务

  const fetchLoading = [true, 'true'].includes(store.fetchLoading)  // 数据获取中
  const basicNotOver = [null, ''].includes(storeCommon.resetTime.basicUpdateDownloadTime) // 是否未完成一步验证
  const advancedNotOver = [null, ''].includes(storeCommon.resetTime.advancedUpdateDownloadTime) // 高级数据未下载完成（空 = 未完成）
  // 高级功能门控（对齐 SpyX）：未绑高级 → 跳 /ios/extreme-verification；数据未就绪 → 暂停渲染
  const { gatePending, showUpgradeModal } = useExtremeFeatureAccessGate(advanced)
  const [justVerified, setJustVerified] = useState(false) // 是否为刚完成验证

  // 升级成功后：预缓冲已在 notify 完成，这里重拉详情读 advanced
  useExtremeUpgradeRefresh(
    useCallback(() => {
      setAdvanced(true)
      dispatch(fetchChatsContacts())
    }, [dispatch])
  )

  useEffect(() => {
    setAdvanced(store.advanced === true || store.advanced === 'true')
  }, [store])

  return (
    <>
      <div
        className='relative bg-[100px] flex justify-center Bxl:h-[calc(var(--vh2)*100-94px)] Bxls:Headers5:h-[calc(var(--vh2)*100-149px)] Header5:big:h-[calc(var(--vh2)*100-214px)] bigs:h-[calc(var(--vh2)*100-274px)] w-full'
        style={{ borderRadius: '10px 10px 10px 10px' }}
      >
        <Box
          className='app-chat flex-1'
          sx={{
            width: '100%',
            display: 'flex',
            borderRadius: 1,
            position: 'relative',
            boxShadow: skin === 'bordered' ? 0 : 6,
            ...(skin === 'bordered' && { border: `1px solid ${theme.palette.divider}` }),
            borderRadius: '10px 10px 10px 10px'
          }}
        >
          {
            !fetchLoading && !gatePending &&
            <>
              {
                (!basicNotOver && !advancedNotOver && !justVerified) ?
                  <>
                    {/* 高级服务开通提示 */}
                    {showUpgradeModal && <ExtremeUpgradeModal open />}
                  </>
                  :
                  <>
                    {/* 增值服务 iCloud验证流程 */}
                  </>
              }

            </>
          }
          <LineSideBar
            store={store}
            hidden={hidden}
            mdAbove={mdAbove}
            dispatch={dispatch}
            userStatus={userStatus}
            selectMessage={selectMessage}
            getInitials={getInitials}
            sidebarWidth={sidebarWidth}
            setUserStatus={setUserStatus}
            leftSidebarOpen={leftSidebarOpen}
            removeSelectedChat={removeSelectedChat}
            userProfileLeftOpen={userProfileLeftOpen}
            formatDateToMonthShort={formatDateToMonthShort}
            handleLeftSidebarToggle={handleLeftSidebarToggle}
            handleUserProfileLeftSidebarToggle={handleUserProfileLeftSidebarToggle}
            calls={calls}
            setCalls={setCalls}
            chat={chat}
            contacts={contacts}
            headImg={headImg}
            setChat={setChat}
            setHaedImg={setHaedImg}
            setContacts={setContacts}
            setLeftScrollTop={setLeftScrollTop}
            leftScrollTop={leftScrollTop}
            advanced={advanced}
          />
          {chat && (
            <LineContent
              store={store}
              hidden={hidden}
              mdAbove={mdAbove}
              dispatch={dispatch}
              getInitials={getInitials}
              sidebarWidth={sidebarWidth}
              userProfileRightOpen={userProfileRightOpen}
              handleLeftSidebarToggle={handleLeftSidebarToggle}
              headImg={headImg}
              setHaedImg={setHaedImg}
              advanced={advanced}
            />
          )}
        </Box>
        {advanced && !fetchLoading && !gatePending && store.list.length == 0 &&
          <div className='text-center px-2 bg-white rounded-[10px] absolute z-[10] inset-0 flex justify-center items-center pointer-events-none'>
            {t('It appears theres no data to show here yet')}<br />
            {t('If data exists it may take up to 1 hour to download and appear')}<br />
            {t('We suggest checking back in a little while')}
          </div>}
      </div>
    </>
  )
}

Line.contentHeightFixed = true

export default Line


